import { render, staticRenderFns } from "./HoldFeesStatsPanel.vue?vue&type=template&id=b7753690&scoped=true&"
import script from "./HoldFeesStatsPanel.vue?vue&type=script&lang=js&"
export * from "./HoldFeesStatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./HoldFeesStatsPanel.vue?vue&type=style&index=0&id=b7753690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7753690",
  null
  
)

export default component.exports